/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RapportHopeEditDto
 */
export interface RapportHopeEditDto {
    /**
     * 
     * @type {number}
     * @memberof RapportHopeEditDto
     */
    idrapportHope?: number;
    /**
     * 
     * @type {string}
     * @memberof RapportHopeEditDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RapportHopeEditDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RapportHopeEditDto
     */
    actif?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof RapportHopeEditDto
     */
    path?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RapportHopeEditDto
     */
    idrapportHopeType?: number;
    /**
     * 
     * @type {string}
     * @memberof RapportHopeEditDto
     */
    categorie?: string | null;
}

/**
 * Check if a given object implements the RapportHopeEditDto interface.
 */
export function instanceOfRapportHopeEditDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RapportHopeEditDtoFromJSON(json: any): RapportHopeEditDto {
    return RapportHopeEditDtoFromJSONTyped(json, false);
}

export function RapportHopeEditDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RapportHopeEditDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idrapportHope': !exists(json, 'idrapportHope') ? undefined : json['idrapportHope'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'idrapportHopeType': !exists(json, 'idrapportHopeType') ? undefined : json['idrapportHopeType'],
        'categorie': !exists(json, 'categorie') ? undefined : json['categorie'],
    };
}

export function RapportHopeEditDtoToJSON(value?: RapportHopeEditDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idrapportHope': value.idrapportHope,
        'nom': value.nom,
        'description': value.description,
        'actif': value.actif,
        'path': value.path,
        'idrapportHopeType': value.idrapportHopeType,
        'categorie': value.categorie,
    };
}

